











































































































import Vue from "vue";
import Api from "../../base/api.typings";
import Component from "vue-class-component";
import painelService from "./painel-service";
import routerService from '../../base/router-service';
import areaService from '../area-atual/area-service';

@Component
export default class PainelAdminListar extends Vue {
    resumo: Api.App.Server.Painel.PainelAdminListar.ResultadoDto = {
        quantidadeChamado: null,
        quantidadeUpload: null,
        quantidadeUsuarioNovo: null,
        quantidadeUsuarioTotal: null
    };

    get carregando() { return !this.resumo };

    ultimaAtualizacao: string = null;

    areaAtual: string = null;

    periodos = [
        { value: Api.Common.Domain.PainelPeriodoEnum.Hoje, text: 'Hoje' },
        { value: Api.Common.Domain.PainelPeriodoEnum.SeteDias, text: 'Últimos 7 dias' },
        { value: Api.Common.Domain.PainelPeriodoEnum.DezDias, text: 'Últimos 10 dias' },
        { value: Api.Common.Domain.PainelPeriodoEnum.VinteDias, text: 'Últimos 20 dias' },
        { value: Api.Common.Domain.PainelPeriodoEnum.TrintaDias, text: 'Últimos 30 dias' },
    ];

    filtro: Api.Common.Domain.PainelPeriodoEnum = 1;
    get filtroData(): Api.Common.Domain.PainelPeriodoEnum { return this.filtro };

    private async listar() {
        let resultado = await painelService.listarPainelAdmin({
            periodo: this.filtroData
        });
        this.resumo = resultado;

        let hora = new Intl.DateTimeFormat('pt-BR', { hour: '2-digit' }).format(new Date);
        let minuto = new Intl.DateTimeFormat('pt-BR', { minute: '2-digit' }).format(new Date);
        let data = new Intl.DateTimeFormat('pt-BR', { month: '2-digit', day: '2-digit' }).format(new Date);
        this.ultimaAtualizacao = `${data} às ${hora}h${minuto}`;
    }

    async escolherEmpresa() {            
        await routerService.goTo('empresa-atual-listar');
        window.location.reload();
    }

    beforeRouteUpdate() {
        this.listar();
    }

    async created() {
        this.areaAtual = await areaService.obterAreaPadrao();
        if (this.areaAtual == 'admin') {
            this.listar();
        }
    }
}
